import { getLineHeight } from '../core/libs/ui-helper';

let bool = true;
export default class DiagramService {


    constructor($q, $localStorage, $timeout, audioService, $interval) {
        'ngInject';

        this.slotBoxes = {};

        Object.assign(this, { $q, $timeout, audioService, $interval });
    }

    init(diagramId, submitBtn, nextBtn, diagramNumber, demo = false,{slotsQuery = 'div:not(.fixed-answer, .empty-draggable-box, .element-arr, .long-arr, .long-arr-part1, .long-arr-part2, .long-arr-part1 .empty-box)'} = {}) {
      this.initDiagram(diagramId, diagramNumber, demo, {slotsQuery});
    }

    initDraggableList(diagramId, submitBtn, nextBtn, diagramNumber, demo = false, {slotsQuery = 'div:not(.fixed-answer, .empty-draggable-box, .element-arr, .long-arr, .long-arr-part1, .long-arr-part2, .long-arr-part1 .empty-box)'} = {}) {
        this.draggableList(diagramId, diagramNumber, demo, {slotsQuery});
    }

    initDiagram(diagramId, diagramNumber, demo, {slotsQuery}) {
        let self = this;

        $(`#${diagramId} .element`)
            .each(function (i) {
                $(this)
                    .data('number',
                        $(this)
                            .attr('id')
                            .replace(`element_${diagramNumber}_`, '')
                    ).draggable({
                        containment: `#${diagramId}`,
                        cursor: 'hand',
                        scroll: false,
                        disabled: demo,
                        revert: function (event, ui) {
                            $(this).data("uiDraggable").originalPosition = {
                                top: 0,
                                left: 0
                            };
                            return !event;
                        }
                    });
                    this.setAttribute('data-index', Math.floor(Math.random() * (10000 - 0)));
            });

        $(`#${diagramId} #slots`)
            .find(slotsQuery)
            .each(function () {
                $(this)
                    .data('number',
                        $(this)
                            .attr('id')
                            .replace(`slot_${diagramNumber}_`, ''))
                    .droppable({
                        hoverClass: 'hovered',
                        drop: function (event, ui) { 
                            self.audioService.play('tab');
                            ui.draggable.removeClass('ui-draggable-dragging');

                            const slotNumber = $(this).data('number');
                            const elementNumber = ui.draggable.data('number');
                            const currentElement = ui.draggable[0];
                            const answer = $(ui.draggable[0]);
                            const oldElement = this.classList.value.split(' ').find(item => item.indexOf('answer--') > -1);

                            if (slotNumber == elementNumber) {
                                currentElement.setAttribute('data-answer', 'correct');
                            }
                            else {
                                currentElement.setAttribute('data-answer', 'wrong');
                            }

                            if (oldElement) {
                                const index = oldElement.split('--')[1];
                                const elemetn = $($('td').find(`.element[data-index="${index}"]`)[0]);

                                elemetn.animate({
                                    top: '3px',
                                    left: '0px',
                                });
                                $(this).removeClass(oldElement);
                            }

                            answer.data('index') == $(this).data('index') ? $(this).addClass('answer__correct') : $(this).addClass('answer__incorrect');

                            $(this).addClass(`answer--${answer.data('index')}`);

                            const ansverPosition = function () {
                                ui.draggable.position({
                                    of: $(this),
                                    my: 'center',
                                    at: 'center'
                                });
                            }
                            setTimeout($.proxy(ansverPosition, $(this)),300);
                        },

                        out: function (event, ui) { 
                            const answer = $(ui.draggable[0]);
                            const container = $(this);
                            const index = answer.data('index');
                            const currentElement = ui.draggable[0];

                            currentElement.setAttribute('data-answer', '');
                            currentElement.classList.remove('correct', 'wrong');

                            $(this).removeClass(ui.draggable[0].id);

                            if (container.hasClass(`answer--${index}`)) {
                                container.removeClass(`answer--${$(ui.draggable[0]).data('index')}`);
                                container.removeClass('answer__incorrect');
                                container.removeClass('answer__correct');
                            }
                        }
                    });
            });
    }

    clearScrollHandler() {
      this.$interval.cancel(this.interval);
    }

    initSCQDiagram(id, dragginOutside, first) {

        if (first) {
          this.interval = this.$interval(() => {
            const position = window.scrollY;
            if (this.scrollUp) {
              window.scrollTo(0, position - 10);
            } else if (this.scrollDown) {
              window.scrollTo(0, position + 10);
            }
          }, 30);
        }

        var self = this;
        const draggableOptions = {
            cursor: 'hand',
            scroll: false,
            revert: function (event, ui) {
                $(this).data("uiDraggable").originalPosition = {
                    top: 0,
                    left: 0
                };
                return !event;
            },
          drag: (event, ui) => {
              // handle 4b2 exercises
              if (window.location.href.includes('4b2')) {
                try {
                  const dragbleSize = (parseInt(event.target.style.height.replace('px', '')) * 1.3) + 'px'
                  const parentMaxSize = event.target.parentElement.offsetHeight + 'px'
                  if (this.dragbleSize) {
                    event.target.parentElement.style.height = this.parentMaxSize
                    event.target.style.height = this.dragbleSize
                  } else {
                    this.dragbleSize = dragbleSize
                    this.parentMaxSize = parentMaxSize
                    event.target.parentElement.style.height = parentMaxSize
                    event.target.style.height = dragbleSize
                  }
                } catch (e) {
                }
              }
              const screen = $( window ).innerHeight();
              if (event.screenY >= screen * 0.9) {
                this.scrollUp = false;
                this.scrollDown = true;
              } else if (event.screenY <= screen * 0.3) {
                this.scrollUp = true;
                this.scrollDown = false;
              } else {
                this.scrollUp = false;
                this.scrollDown = false;
              }
          },
          stop: (event, ui) => {
            if (window.location.href.includes('4b2') && !$(event.target).hasClass('simplest__structure-answer--dropped')) {
                event.target.style.height = '100%'
            }
            this.scrollUp = false;
            this.scrollDown = false;
          }
        };

        if (!dragginOutside) {
            draggableOptions.containment = `#${id}`;
        }

        $(`#${id} .simplest__structure-answer`)
            .each((i, element) => $(element).draggable(draggableOptions));

        $(`#${id} .simplest__structure-box`)
            .each(function (i, element) {
                $(this)
                    .droppable({
                        hoverClass: 'hovered',
                        drop: function (event, ui) {
                            self.audioService.play('tab');

                            const answer = $(ui.draggable[0]);
                            const parentWrapper = $(ui.draggable[0]).parent();
                            const oldElement = this.classList.value.split(' ').find(item => item.indexOf('answer--') > -1);

                            answer.addClass('simplest__structure-answer--dropped');
                            parentWrapper.css({ height: parentWrapper.outerHeight(true)});
                            answer.css({ width: $(this).width(), height: $(this).height() });

                            const lineHeight = getLineHeight(answer['0']);
                            const rowsAmount = parseInt(Number(answer.outerHeight() - lineHeight - 10) / lineHeight, 10);

                            const boxTextBeforeHidden = answer.find('.simplest__box-text').outerHeight();

                            // Logic for arrow tooltip in the box
                            if (boxTextBeforeHidden < (answer.outerHeight() - lineHeight - 10)) {
                              answer.find('.simplest__box-text').css({height: '' , overflow: ''});
                              answer.find('.simplest__arrow-button').css({display: 'none', 'justify-content': ''});
                            } else {
                              answer.find('.simplest__box-text').css({height: rowsAmount * lineHeight , overflow: 'hidden'});
                              answer.find('.simplest__arrow-button').css({display: 'flex', 'justify-content': 'flex-end'});
                            }

                            if (oldElement) { 
                                const index = oldElement.charAt(oldElement.length - 1);
                                const elemetn = $(`.simplest__structure-answer[data-index="${index}"]`);
                                elemetn.find('.simplest__box-text').css({height: '' , overflow: ''});
                                elemetn.find('.simplest__arrow-button').css({display: 'none', 'justify-content': ''})
                                elemetn.css({
                                  width: 'auto',
                                  height: 'auto'
                                })
                                elemetn.animate({
                                    top: '0px',
                                    left: '0px',
                                    width: 'auto',
                                    height: 'auto'
                                });
                                elemetn.removeClass('simplest__structure-answer--dropped');
                                $(this).removeClass(oldElement);
                            }

                            answer.position({
                                of: $(this),
                                my: 'center',
                                at: 'center'
                            });

                            const resizeEvent = () => {
                              answer.css({width: $(this).width(), height: $(this).height()});
                              answer.position({
                                of: $(this),
                                my: 'center',
                                at: 'center'
                              });
                            }

                            var resizeFunc;
                            $(window).resize(() => {
                              clearTimeout(resizeFunc);
                              resizeFunc = setTimeout(resizeEvent, 100);
                            });

                            window.visualViewport.addEventListener('resize', () => {
                              answer.css({width: $(this).width(), height: $(this).height()});
                              answer.position({
                                of: $(this),
                                my: 'center',
                                at: 'center'
                              });

                              // Logic for arrow tooltip in the box
                              answer.find('.simplest__box-text').css({height: '' , overflow: ''});
                              answer.find('.simplest__arrow-button').css({display: 'none', 'justify-content': ''});

                              if (ui.draggable[0].scrollHeight <= answer.outerHeight()) {
                                answer.find('.simplest__box-text').css({height: '' , overflow: ''});
                                answer.find('.simplest__arrow-button').css({display: 'none', 'justify-content': ''});
                              } else {
                                answer.find('.simplest__box-text').css({height: rowsAmount * lineHeight , overflow: 'hidden'});
                                answer.find('.simplest__arrow-button').css({display: 'flex', 'justify-content': 'flex-end'});
                              }
                            })

                            $(this).removeClass('answer__incorrect');
                            $(this).removeClass('answer__correct');
                            const isDataArray = Array.isArray($(this).data('index'));
                            if (isDataArray) {
                              const values = $(this).data('index');
                              const correctAnswer = answer.data('index');
                              const isValueExist = values.find(element => element === Number(correctAnswer));
                              isValueExist ? $(this).addClass('answer__correct') : $(this).addClass('answer__incorrect');
                            } else {
                              answer.data('index') == $(this).data('index') ? $(this).addClass('answer__correct') : $(this).addClass('answer__incorrect');
                            }

                            $(this).addClass(`answer--${answer.data('index')}`);
                        },
                        out: function (event, ui) {
                            const answer = $(ui.draggable[0]);
                            const container = $(this);
                            const index = answer.data('index');
                            if (container.hasClass(`answer--${index}`)) {
                                answer.removeClass('simplest__structure-answer--dropped');
                                answer.css({ width: '', height: '' });
                                answer.find('.simplest__box-text').css({height: '' , overflow: ''});
                                answer.find('.simplest__arrow-button').css({display: 'none', 'justify-content': ''});
                                container.removeClass(`answer--${$(ui.draggable[0]).data('index')}`);
                                container.removeClass('answer__incorrect');
                                container.removeClass('answer__correct');
                            }
                        }
                    });
            });

    }

    draggableList(diagramId, diagramNumber, demo, {slotsQuery}) {
        let self = this;

        $(`#${diagramId} .list-element`)
            .each(function () {
                $(this)
                    .data('number',
                        $(this)
                            .attr('id')
                            .replace(`element_${diagramNumber}_`, '')
                    ).draggable({
                        containment: `#${diagramId}`,
                        cursor: "hand", cursorAt: { top: 0, left: 150 },
                        scroll: false,
                        disabled: demo,
                        revert: function (event, ui) {
                            const answer = $(this)
                            answer.removeClass('element-list_drop');
                            answer.data("uiDraggable").originalPosition = {
                                top: 0,
                                left: 0
                            };
                            return !event;
                        },
                        drag: function (event, ui) {
                          ui.helper.removeClass('element-list_drop');
                          ui.helper.removeClass(function (index, className) {
                            return (className.match (/(^|\s)element-list_drop\S+/g) || []).join(' ');
                          });
                        }
                    });
            });

        $(`#${diagramId} #slots`)
            .find(slotsQuery)
            .each(function () {
                $(this)
                    .data('number',
                        $(this)
                            .attr('id')
                            .replace(`slot_${diagramNumber}_`, ''))
                    .droppable({
                        hoverClass: 'hovered',
                        drop: function (event, ui) {
                            self.audioService.play('tab');
                            ui.draggable.removeClass('ui-draggable-dragging');

                            const ansverPosition = function () {
                                const oldElement = $(`.element-list_drop-${event.target.id}`)
                                if (oldElement.length) {
                                  oldElement.animate({
                                    top: '0px',
                                    left: '0px',
                                    width: 'auto',
                                    height: 'auto'
                                  });
                                  oldElement.removeClass('element-list_drop');
                                  oldElement.removeClass(`element-list_drop-${event.target.id}`);
                                }
                                ui.draggable.addClass('element-list_drop');
                                ui.draggable.addClass(`element-list_drop-${event.target.id}`);
                                ui.draggable.position({
                                    of: $(this),
                                    my: 'center',
                                    at: 'center'
                                });
                            };
                            setTimeout($.proxy(ansverPosition, $(this)), 0);
                        },

                        out: function (event, ui) {
                          ui.draggable.removeClass(`element-list_drop-${event.target.id}`);
                          ui.draggable.removeClass('element-list_drop');
                            $(this).removeClass(ui.draggable[0].id);
                        }
                    });
            });
    }

    disableSCQDiagram(id) {
        $(`#${id} .simplest__structure-answer`)
            .each(function () {
                $(this).draggable('disable');
            });
    }

    removeOldClass(element) {
        element.classList.remove('correct', 'wrong');
    }

    checkDiagramAnswers(diagramId) { 
        const elements = document.querySelectorAll(`#${diagramId} .element`);
        elements.forEach( element => {
            this.removeOldClass(element);
            if (element.getAttribute('data-answer') == 'correct') {
                const selector = `#${diagramId} [data-answer="correct"]`;
                $(selector).css('border-color', 'white');
                setTimeout(() => $(selector).css('border-color', 'transparent'), 200);
            }
        });

        const correctAnswersCounter = document.querySelectorAll(`#${diagramId} [data-answer="correct"]`).length;

        if (correctAnswersCounter === elements.length) {
            $(`#${diagramId} .element`).each(function () {
                $(this).draggable('disable');
            });
            return true;
        } else {
            return false;
        }

    }

    checkRadioButtons(diagramId) {
      const elements = document.querySelectorAll(`#${diagramId} input`);
      let invalidInput;
      Array.from(elements).forEach(input => {
        if ((input.dataset.answer !== 'true') && input.checked) {
          invalidInput = input;
        }
      });
      if (invalidInput) {
        const elementBorder = document.querySelector(`#${diagramId} label[for="${invalidInput.id}"].radio-button`);
        $(elementBorder).css('border-color', 'red');
        setTimeout(() => {
          $(elementBorder).attr('style', '')
        }, 200);
      } else {
        return true
      }
    }

    checkDiagramCheckboxesAnswers(userAnswers, correctAnswers) {
        const progress = {
            complete: true,
            mistake: {},
            correct: {},
            correctIndex: [],
            incorrectIndex: [],
        };

        for (let k in correctAnswers) {
            const index = parseInt(k.match(/\d+/)[0]) - 1;
            if (correctAnswers[k] !== userAnswers[k]) {
                if (!correctAnswers[k]) {
                    progress.incorrectIndex.push(index);
                }

                progress.complete = false;
                progress.mistake[k] = false;
            } else if (correctAnswers[k] === true && userAnswers[k] === true) {
                progress.correctIndex.push(index);
                progress.correct[k] = true;
            }

        }
        return this.$q.resolve(progress);
    }

    checkBoxHint(diagramId, checkbox, correctIndex, incorrectIndex, correctAnswers) {
        if (checkbox) {
            const checkboxes = $(`#${diagramId} .checkbox`);
            if (incorrectIndex.length && !correctIndex.length) {
                incorrectIndex.forEach(i => {
                    this.highlightCheckbox(checkboxes, i);
                });
                for (let i in correctAnswers) {
                    if (correctAnswers[i]) {
                        const index = parseInt(i.match(/\d+/)[0]) - 1;
                        this.highlightCheckbox(checkboxes, index);
                    }
                }
            } else if (correctIndex.length && incorrectIndex.length) {
                incorrectIndex.forEach(i => {
                    this.highlightCheckbox(checkboxes, i);
                });
            } else if (correctIndex.length && !incorrectIndex.length) {
                for (let i in correctAnswers) {
                    if (correctAnswers[i]) {
                        const index = parseInt(i.match(/\d+/)[0]) - 1;
                        if (correctIndex.indexOf(index) === -1) {
                            this.highlightCheckbox(checkboxes, index);
                        }
                    }
                }
            }
        } else {
          const selector = `#${diagramId} .element:not([data-answer="correct"])`;
          const jQueryNodes = $(selector)
          if (!jQueryNodes.length) {
            return true
          }
          jQueryNodes.css('border-color', 'red');
          setTimeout(() => jQueryNodes.css('border-color', 'transparent'), 200);
        }

    }

    highlightOnlyIncorectDragbleBoxes(diagramId) {
      const elements = document.querySelectorAll(`#${diagramId} .element[data-answer="wrong"]`);
      if (!elements.length) {
        return true
      }
      elements.forEach((element) => {
        const $element = $(element);
        if ($element.css('left') !== '0px') {
          $element.css('border-color', 'red');
          setTimeout(() => $element.css('border-color', 'transparent'), 200);
        }
      });
    }

    highlightCheckbox(array, i) {
        const checkbox = $(array[i]);
        checkbox.addClass('checkbox__hint');
        setTimeout(() => checkbox.removeClass('checkbox__hint'), 200);
    }

    addAnswers(el, ui) { 
        const slotNumber = $(el).data('number');
        const elementNumber = ui.draggable.data('number');
        const currentElement = ui.draggable[0]

        if (slotNumber == elementNumber) {
            currentElement.setAttribute('data-answer', 'correct');
        } else {
            currentElement.setAttribute('data-answer', 'wrong');
        };
    }

    updateElements(el, ui) {
        const currentElement = ui.draggable[0];
        if ($(el).is('[class*="element"]')) {
            const oldElementClass = $(el).attr('class').split(' ').pop();
            const oldElement = $(`#${oldElementClass}`)[0];
            if (oldElement != currentElement) {
                $(oldElement).animate({
                    top: "4px",
                    left: "8px"
                });
                $(el).removeClass(oldElementClass);
                $(el).addClass(currentElement.id);
            }
        } else {
            $(el).addClass(currentElement.id);
        }
    }

    reset(diagramId, ) {
        const self = this;
        const promiseArray = [];
        $(`#${diagramId} .element`).each(function (index) {
            const element = $(this);

            promiseArray.push(self.$timeout(function () {
                element.animate({
                    top: 0,
                    left: 0
                }, function () {
                    $(this).removeClass('correct wrong').draggable('enable').removeAttr('data-answer');
                });
            }, 1000 * index));
        });
        return this.$q.all(promiseArray);
    }

    autocomplete(diagramId, instant) { 
        const timeFrame = instant ? 0 : 1000;
        const self = this;
        const blocks = $(`#${diagramId} .element`);
        const promiseArray = [];
        blocks.each(function (index) { 
            const itemNumber = $(this).data('item');
            const element = $(this);

            promiseArray.push(self.$timeout(function () {
                element.position({
                    my: 'center',
                    at: 'center',
                    of: $(`.slot[data-item="${itemNumber}"]`),
                    using: function (position) {
                        $(this).animate(position, 'slow', 'linear', function () {
                            $(this).addClass('correct')
                        });
                    }
                });
            }, timeFrame * index));
        });

        return this.$q.all(promiseArray);

    }

    guid() {
        const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    }

    radioButtonsHint(diagramId, userAnswer, correctAnswer) {
      const radioButtons = $(`#${diagramId} .checkbox`);
      Array.from(radioButtons).forEach((radioButton) => {
        const input = $( radioButton ).find('input').val();
        if (input === correctAnswer) {
          const label = $( radioButton ).find('label');
          label.css('border', '3px solid red');
          setTimeout(() => label.removeAttr('style'), 200);
        }
      });
    }

    radioButtonsGroupHint(diagramId, userAnswer, correctAnswer, number) {
      const radioButtons = $(`#${diagramId} #${number} .checkbox`);
      const radioButtonsTask = $(`#${diagramId} .checkboxes-task-item .checkbox`);
      this.highlightLabel(radioButtons,  userAnswer[0], correctAnswer[0]);
      this.highlightLabel(radioButtonsTask,  userAnswer[1], correctAnswer[1]);
    }

    highlightLabel(inputs, userAnswer, correctAnswer,) {
      Array.from(inputs).forEach((radioButton) => {
        const input = $( radioButton ).find('input').val();
        if (userAnswer !== correctAnswer && (input == userAnswer || input == correctAnswer)) {
          const label = $( radioButton ).find('label');
          label.css('border', '3px solid red');
          setTimeout(() => label.removeAttr('style'), 200);
        }
      });
    }

    checkFixedAnswersDiagram(diagramId) {
      const elements = document.querySelectorAll(`#${diagramId} .drag-element`);
      elements.forEach( element => {
        this.removeOldClass(element);
        if (element.getAttribute('data-answer') == 'correct') {
          const selector = `#${diagramId} [data-answer="correct"]`;
          $(selector).css('border-color', 'white');
          setTimeout(() => $(selector).css('border-color', 'transparent'), 200);
        }
      });

      const correctAnswersCounter = document.querySelectorAll(`#${diagramId} [data-answer="correct"]`).length;

      if (correctAnswersCounter === elements.length) {
        $(`#${diagramId} .element`).each(function () {
          $(this).draggable('disable');
        });
        return true;
      } else {
        return false;
      }
    }
}



// WEBPACK FOOTER //
// ./client/app/services/diagram.service.js